import { render, staticRenderFns } from "./character-recognition.vue?vue&type=template&id=d276697e&scoped=true&"
import script from "./character-recognition.vue?vue&type=script&lang=js&"
export * from "./character-recognition.vue?vue&type=script&lang=js&"
import style0 from "./character-recognition.vue?vue&type=style&index=0&lang=css&"
import style1 from "./character-recognition.vue?vue&type=style&index=1&id=d276697e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d276697e",
  null
  
)

export default component.exports